import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { ClinicLocationsResponse } from '@chiroup/core/types/ClinicMapLocation.type';

const clinicMapService = () => {
  const getLocations = async (): Promise<ClinicLocationsResponse> => {
    return ChiroUpAPI.get('api', '/clinics/locations', {});
  };

  return {
    getLocations,
  };
};

export default clinicMapService();
